import * as React from "react";
import {cs} from "../../../../../../../../../react/chain-services";
import "./scroll-buttons.scss";

export const ScrollButtons = ({onLeft, onRight}) => cs(
    () => (
        <div className="scroll-buttons scroll-buttons-00x">
            <button
                onMouseDown={onLeft}
            ><i className="fa fa-chevron-left" /></button>
            <button
                onMouseDown={onRight}
            ><i className="fa fa-chevron-right"/></button>
        </div>
    ),
);
